// @flow

import React, { Component } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";

const styles = (theme: DictionaryType): DictionaryType => ({
  menuItemSelected: {
    background: theme.palette.primary.light + " !IMPORTANT",
    "& $text, & $icon": {
      color: theme.palette.primary.contrastText
    }
  },
  text: {},
  icon: {}
});

type AppbarMenuItemClassesType = {
  menuItemSelected: DictionaryType,
  text: DictionaryType,
  icon: DictionaryType
};

type AppbarMenuItemPropType = {
  classes: AppbarMenuItemClassesType,
  text: string,
  selected?: boolean,
  icon?: React$Element<*>,
  onClick?: Function
};

class AppbarMenuItem extends Component<*, AppbarMenuItemPropType> {
  render(): React$Element<*> {
    const classes = this.props.classes;

    return (
      <MenuItem
        classes={{ selected: classes.menuItemSelected }}
        selected={this.props.selected}
        {...(this.props.onClick ? { onClick: this.props.onClick } : {})}
      >
        {this.props.icon && (
          <ListItemIcon className={classes.icon}>
            {this.props.icon}
          </ListItemIcon>
        )}
        <ListItemText
          classes={{ primary: classes.text }}
          inset
          primary={this.props.text}
        />
      </MenuItem>
    );
  }
}

export default withStyles(styles)(AppbarMenuItem);
